import { Toast } from '@navinc/base-react-components'
import styled from 'styled-components'

const MessageContainer = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  width: 100%;
`

const Grid = styled.div`
  display: grid;
  grid-gap: 8px;
  max-width: 544px;
  width: 100%;
  position: absolute;
  top: 8px;
`

export const ToastBar = ({ className }) => (
  <MessageContainer className={className}>
    <Grid>
      <Toast />
    </Grid>
  </MessageContainer>
)
